const requests = [
  {
    path: 'product-trainings-request',
    name: 'product_trainings_request',
    icon: 'cil-short-text',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/requests/online_trainings/List.vue')
    },
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'trainings'
    }
  },
  {
    path: 'bridgestone-courses-request',
    name: 'bridgestone_courses_request',
    icon: 'cil-chat-bubble',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/requests/bridgestone_trainings/List.vue')
    },
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'b-trainings'
    }
  },
  {
    path: 'external-trainings-request',
    name: 'external_trainings_request',
    icon: 'cil-chat-bubble',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/requests/external_trainings/List.vue')
    },
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'external-trainings-request'
    }
  },
  {
    path: 'investment-support-request',
    name: 'investments_request',
    icon: 'cil-chat-bubble',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/requests/investment_support/List.vue')
    },
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'investments-request'
    }
  },

  {
    path: 'sales-promotions',
    name: 'salespromotions',
    icon: 'cil-chat-bubble',
    showInMenu: true,
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'sales-promotions'
    },
    children: [
      {
        path: '',
        name: 'salespromotions_list',
        components: {
          content: () => import('@/views/pages/requests/sales-promotions/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'sales-promotions'
        }
      },
      {
        path: ':id',
        name: 'salespromotions_view',
        components: {
          content: () => import('@/views/pages/requests/sales-promotions/View.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'sales-promotions'
        }
      }
    ]
  },

  {
    path: 'uberall-request',
    name: 'uberall_request',
    icon: 'cil-chat-bubble',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/requests/uberall/List.vue')
    },
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'uberall'
    }
  }
]

export default requests
